/* src/app/module/service-provider/add-sp-new-component/brand-details/brand-details.component.scss */
.cards {
  display: flex;
  width: 768px;
  padding: 16px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Gray-200, #e4e7ec);
  background: var(--White, #fff);
  transition: border-color 0.3s ease;
  cursor: pointer;
}
.heading {
  margin-bottom: 43px;
  font-size: 20px;
  font-weight: 600;
}
::ng-deep .cards:hover {
  border-color: #4b5563 !important;
}
::ng-deep .p-checkbox-box.p-highlight {
  background-color: #FFC680 !important;
  border-color: #FFC680 !important;
}
::ng-deep .p-checkbox-box:hover {
  border-color: orange !important;
}
::ng-deep .p-checkbox-box:focus-within,
::ng-deep .p-checkbox-box.p-focus {
  box-shadow: 0 0 0 2px rgba(255, 198, 128, 0.4) !important;
  border-color: #FFC680 !important;
}
/*# sourceMappingURL=brand-details.component-JIN3IGFF.css.map */
